import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import LoadingFallback from '../components/LoadingFallback'

function ProtectedRoute({children}) {
    const { currentUser, loading } = useAuth();
    const [isInitialized, setIsInitialized] = useState(false);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Tambahkan delay untuk memastikan semua komponen sudah siap di mobile/tablet
        const initTimer = setTimeout(() => {
            setIsInitialized(true);
        }, 150);

        // Timer tambahan untuk memastikan rendering yang stabil
        const readyTimer = setTimeout(() => {
            setIsReady(true);
        }, 300);

        return () => {
            clearTimeout(initTimer);
            clearTimeout(readyTimer);
        };
    }, []);

    // Tampilkan loading jika masih dalam proses inisialisasi atau loading
    if (loading || !isInitialized || !isReady) {
        return <LoadingFallback message="Memuat aplikasi..." />;
    }

    // Jika tidak ada user yang login, redirect ke halaman login
    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // Jika semua kondisi terpenuhi, tampilkan children
    return children;
}

export default ProtectedRoute